var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDistalMesial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5C9.27614 15.5 9.5 15.2761 9.5 15C9.5 14.7239 9.27614 14.5 9 14.5V15.5ZM1 15L6 17.8868V12.1132L1 15ZM9 14.5H5.5V15.5H9V14.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14.5C22.7239 14.5 22.5 14.7239 22.5 15C22.5 15.2761 22.7239 15.5 23 15.5V14.5ZM31 15L26 12.1132V17.8868L31 15ZM23 15.5H26.5V14.5H23V15.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6543 24.9687C18.7819 24.9896 18.9043 25 19.0266 25C19.9681 25 20.766 24.3419 20.9894 23.4384C21.7766 20.2317 24 12.5649 24 10.5803C24 8.0525 21.9096 6 19.3351 6C18.6809 6 18.0585 6.13057 17.4947 6.37081C17.0213 6.56927 16.5106 6.67372 16 6.67372C15.4894 6.67372 14.9787 6.57449 14.5053 6.37081C13.9415 6.13057 13.3191 6 12.6649 6C10.0904 6 8 8.0525 8 10.5803C8 12.3194 10.2021 20.2317 10.9734 23.4384C11.1915 24.3419 11.9894 25 12.9362 25C13.0585 25 13.1862 24.9896 13.3138 24.9634C14.2713 24.7859 14.9362 23.9241 14.9362 22.9684V20.7905C14.9362 19.9601 15.4043 19.5006 15.984 19.5006C16.5638 19.5006 17.0319 19.9601 17.0319 20.5294V22.9684C17.0319 23.9241 17.6968 24.7911 18.6596 24.9687H18.6543Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistalMesial);
export default __webpack_public_path__ + "static/media/Icon_Distal_Mesial.72d7d77ab1eb8a63f27818004fc79999.svg";
export { ForwardRef as ReactComponent };